<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" placeholder="搜索名称" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select v-model="queryParam.status" placeholder="请选择" allowClear>
                <a-select-option value="1">进行中</a-select-option>
                <a-select-option value="3">未开始</a-select-option>
                <a-select-option value="4">已结束</a-select-option>
                <a-select-option value="2">已下架</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd">新建</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="setAllStatus(1)" key="1">
            <a-icon type="upload" />上架
          </a-menu-item>
          <a-menu-item @click="setAllStatus(2)" key="2">
            <a-icon type="download" />下架
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="title1" slot-scope="text,record">
        <div style="margin-bottom: 10px;">{{record.title}}</div>
        <div>
          <div style="color: #999;">
            <span
              v-if="record.price_end>0"
              style="color: #f5212d"
            >¥{{record.price_start|price}} - {{record.price_end|price}}</span>
            <span v-else style="color: #f5212d">¥{{record.price_start|price}}</span>
            <br />
            <span v-if="record.price_limit>0">
              最低消费
              <em style="color: #f5212d">¥{{record.price_limit|price}}</em>
              <br />
            </span>
            <a-badge status="success" v-if="record.status==1" text="进行中" />
            <a-badge status="processing" v-else-if="record.status==3" text="未开始" />
            <a-badge status="default" v-else-if="record.status==4" text="已结束" />
            <a-badge status="default" v-else text="已下架" />
          </div>
        </div>
      </span>
      <span slot="timeRange" slot-scope="text,record">
        <template>
          <div>
            <span v-if="record.use_day_limit">领取后{{record.use_day_limit}}天内</span>
            <span v-else>
              {{record.use_time_start|timeFormat}}
              <br />
              {{record.use_time_end|timeFormat}}
            </span>
          </div>
        </template>
      </span>
      <span slot="orderCount" slot-scope="text,record">
        <template>
          <div>{{record.order_count}}/{{record.user_count}}/{{record.get_count}}</div>
        </template>
      </span>
      <span slot="userGetNumLimit" slot-scope="text,record">
        <template>
          <div>
            <span v-if="record.user_get_num_limit>0">每人{{record.user_get_num_limit}}张</span>
            <span v-else>不限制</span>
            <br />
            <span>库存{{record.count}}</span>
          </div>
        </template>
      </span>
      <span slot="action" slot-scope="text,record">
        <template>
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleUserManage(record)">领取记录</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
            <a href="javascript:;" @click="onShare(record)">小程序推广</a>
            </a-menu-item>
             <a-menu-item>
                <a href="javascript:;" @click="onH5Share(record)">H5版推广</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm okText="确定" cancelText="取消" @confirm="setSend(record)">
                  <span slot="icon" />
                  <template slot="title" style="margin-top:-60px">
                    请选择用户
                    <br />
                    <users-picker
                      style="width:500px; margin-right: 10px; "
                      :formData="userFormData"
                      field="user_list"
                    />
                  </template>
                  <a href="javascript:;" >发送</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm
                  title="删除后不可恢复,确定删除吗?"
                  @confirm="deleteHandle(record)"
                  okText="确定"
                  cancelText="取消"
                >
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
      </span>
    </s-table>
    <a-modal
      title="操作"
      style="top: 20px;"
      :width="1000"
      :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
      v-model="visible"
      @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="标题" hasFeedback>
            <a-input
              v-decorator="[
          'title',
          {rules: [{ required: true, message: '请输入优惠券标题' }]}
        ]"
              placeholder="请输入优惠券标题"
            />
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="描述" hasFeedback>
            <a-textarea
              autosize
              v-decorator="[
          'desc',
          {rules: []}
        ]"
              placeholder="请输入描述"
            />
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发放总量" hasFeedback>
            <a-input
              type="number"
              v-decorator="[
          'count',
          {rules: [{ required: true, message: '请输入数量' }]}
        ]"
              placeholder="优惠券发放的总数"
            />
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="面额类型" hasFeedback>
            <a-radio-group
              :disabled="formData.id>0"
              v-model="formData.price_type"
              buttonStyle="solid"
            >
              <a-radio-button :value="1">随机</a-radio-button>
              <a-radio-button :value="2">固定</a-radio-button>
            </a-radio-group>
          </a-form-item>

          <a-form-item
            v-if="formData.price_type==2"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="固定面额"
            hasFeedback
          >
            <PriceInput
              :formData="formData"
              :disabled="formData.id>0"
              field="price_start"
              placeholder="用户领取优惠券的面额"
            />
          </a-form-item>
          <a-form-item
            v-else
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="随机面额"
            hasFeedback
          >
            <PriceInput
              :formData="formData"
              style="width: 150px;"
              :disabled="formData.id>0"
              field="price_start"
              placeholder="请输入面额下限"
            />
            <PriceInput
              :formData="formData"
              style="width: 150px;"
              :disabled="formData.id>0"
              field="price_end"
              placeholder="请输入面额上限"
            />
          </a-form-item>

          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="使用门槛"
            hasFeedback
            extra="订单满多少元可用此优惠券"
          >
            <PriceInput :formData="formData" field="price_limit" placeholder="优惠券满多少元可用" />
          </a-form-item>

          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="每人限领"
            hasFeedback
            extra="每人限领多少张,为空或者0表示不限"
          >
            <a-input
              type="number"
              v-decorator="[
          'user_get_num_limit',
          {rules: []}
        ]"
              placeholder="每人限领多少张"
            />
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="领取时限" hasFeedback>
            <a-range-picker
              v-model="formData.get_date_range_moment"
              :showTime="{
                  defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
              format="YYYY-MM-DD HH:mm:ss"
            />
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="使用时限类型" hasFeedback>
            <a-radio-group
              v-model="formData.use_date_type"
              :disabled="formData.id>0"
              buttonStyle="solid"
            >
              <a-radio-button :value="1">固定</a-radio-button>
              <a-radio-button :value="2">动态</a-radio-button>
            </a-radio-group>
          </a-form-item>

          <a-form-item
            v-if="formData.use_date_type==1"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="使用时限"
            hasFeedback
            extra="在此时间内有效"
          >
            <a-range-picker
              :disabled="formData.id>0"
              v-model="formData.use_date_range_moment"
              :showTime="{
        defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
      }"
              format="YYYY-MM-DD HH:mm:ss"
            />
          </a-form-item>
          <a-form-item
            v-else
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="使用时限"
            hasFeedback
            extra="领取后几天有效"
          >
            <a-input
              :disabled="formData.id>0"
              v-decorator="[
          'use_day_limit',
          {rules: [{ required: true, message: '领取后几天有效' }]}
        ]"
              placeholder="领取后几天有效"
            />
          </a-form-item>
          <a-form-item label="可用商品" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-select
              optionFilterProp="title"
              mode="multiple"
              v-model="formData.goods_ids"
              placeholder="选择商品"
            >
              <a-select-option
                :key="option.id"
                v-for="option in goodsOptions"
                :title="option.title"
                :disabled="option.disabled"
                :value="option.id"
              >{{option.title}}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="不可用商品" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-select
              optionFilterProp="title"
              mode="multiple"
              v-model="formData.not_goods_ids"
              placeholder="选择商品"
            >
              <a-select-option
                :key="option.id"
                v-for="option in goodsOptions"
                :title="option.title"
                :disabled="option.disabled"
                :value="option.id"
              >{{option.title}}</a-select-option>
            </a-select>
          </a-form-item>

          <!--
          <a-form-item

                  label="用户组限制"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
          >
          </a-form-item>


          <a-form-item
                  label="分销员组限制"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
          >
          </a-form-item>-->

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发放方式" hasFeedback>
            <a-radio-group
              :disabled="formData.id>0"
              v-model="formData.auto_get"
              buttonStyle="solid"
            >
              <a-radio-button value>手动发放</a-radio-button>
              <a-radio-button value="regist">注册自动发放</a-radio-button>
              <a-radio-button value="firstOrder">首次下单后</a-radio-button>
              <a-radio-button value="orderPay">下单支付后</a-radio-button>
            </a-radio-group>
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="领取限制" hasFeedback>
            <a-radio-group
              :disabled="formData.id>0"
              v-model="formData.get_limit"
              buttonStyle="solid"
            >
              <a-radio-button value>不限</a-radio-button>
              <a-radio-button value="newregist">仅新用户</a-radio-button>
            </a-radio-group>
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="限单独使用" hasFeedback>
            <r-switch
              :disabled="formData.id>0"
              :formData="formData"
              field="single_use"
              :checkedValue="1"
              :unCheckedValue="2"
              checkedChildren="是"
              unCheckedChildren="否"
            />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="强制关注公众号" hasFeedback>
            <r-switch
              :formData="formData"
              field="need_subscribe"
              :checkedValue="1"
              :unCheckedValue="2"
              checkedChildren="是"
              v-model="formData.need_subscribe"
              unCheckedChildren="否"
            />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="商品详情可见" hasFeedback>
            <r-switch
              :formData="formData"
              field="goods_show"
              :checkedValue="1"
              :unCheckedValue="2"
              checkedChildren="是"
              v-model="formData.goods_show"
              unCheckedChildren="否"
            />
          </a-form-item>

          <a-form-item
            v-show="formData.goods_show==1"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="商品详情自定义标题"
            hasFeedback
          >
            <a-input
              v-decorator="[
          'goods_show_title',
          {rules: [ ]}
        ]"
              placeholder
            />
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态" hasFeedback>
            <r-switch
              :formData="formData"
              field="status"
              :checkedValue="1"
              :unCheckedValue="2"
              checkedChildren="上架"
              unCheckedChildren="下架"
            />
          </a-form-item>
        </a-form>
      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>

    <a-modal
      title="领取明细"
      :width="1000"
      style="top: 20px;"
      :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
      v-model="userVisible"
      @ok="userVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-table
            :columns="userColumns"
            :dataSource="couponUserList"
            :pagination="userPagination"
            @change="handleUserTableChange"
            rowKey="id"
            :scroll="{ y: 300 }"
            bordered
          >
            <div
              slot="filterDropdown"
              slot-scope="{ setSelectedKeys, selectedKeys, confirm,  }"
              class="custom-filter-dropdown"
            >
              <a-input
                v-model="userQuery.keywords"
                placeholder="搜索用户名/手机号"
                style="width: 188px; margin-bottom: 8px; display: block;"
              />
              <a-button
                type="primary"
                @click="userSearch(selectedKeys, confirm)"
                icon="search"
                size="small"
                style="width: 90px; margin-right: 8px"
              >搜索</a-button>
              <a-button
                @click="userSearchReset(selectedKeys, confirm)"
                size="small"
                style="width: 90px"
              >重置</a-button>
            </div>
            <span slot="name" slot-scope="text,record">{{record.user_name}}</span>
            <span slot="status" slot-scope="text,record">
              <a-badge
                status="processing"
                v-if="record.user_status==1 && record.status_type=='not_effect'"
                text="未生效"
              />
              <a-badge
                status="processing"
                v-if="record.user_status==1 && record.status_type=='can_use'"
                text="未使用"
              />
              <a-badge
                status="success"
                v-else-if="record.user_status==2"
                :text="record.status_name"
              />
              <a-badge status="default" v-else :text="record.status_name" />
            </span>
          </a-table>
        </a-form>
      </a-spin>
    </a-modal>

    <a-modal title="小程序推广" v-model="shareVisible" @ok="shareVisible=false">
      <p style="text-align: center">
        <img :src="share.wxmini_pic_url" />
      </p>
    </a-modal>
    <a-modal title="H5推广" v-model="h5ShareVisible" @ok="h5ShareVisible=false">
      <p style="text-align: center">
        <img :src="share.wxmini_pic_url" />
      </p>
      <p>详情地址</p>
      <p>{{share.site_url}} </p><a  
        v-clipboard:copy="share.site_url"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError">点此复制</a>
    </a-modal>
  </a-card>
</template>

<script>
import STable from '@/components/table/'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
import EditableCell from '@/components/EditableCell/'
import RSwitch from '@/components/RSwitch/'
import PriceInput from '@/components/PriceInput/'
import moment from 'moment'
import UsersPicker from '@/components/UsersPicker/'

import 'moment/locale/zh-cn'
moment.locale('zh-cn')
import {
  getGoodsOptions,
  getCouponList,
  getCouponDetail,
  addCoupon,
  editCoupon,
  deleteCoupon,
  setCouponAllStatus,
  getCouponUserList,
  sendCoupon
} from '@/api/coupon'
import { getShopUserList } from '@/api/businessShop'
export default {
  name: 'CouponList',
  components: {
    AInput,
    ATextarea,
    STable,
    PriceInput,
    EditableCell,
    RSwitch,
    UsersPicker
  },
  data() {
    return {
      visible: false,
      shareVisible: false,
      h5ShareVisible:false,
      saveLoading: false,
      userVisible: false,
      share: {
        wxmini_pic_url: '',
        site_url:'',
      },
      formData: {
        id: 0,
        title: '',
        desc: '',
        count: '',
        price_type: 1,
        price_start: '',
        price_end: '',
        price_limit: '',
        user_get_num_limit: '',
        use_day_limit: '',
        get_date_range: [],
        get_date_range_moment: [],
        use_date_type: 1,
        use_date_range: [],
        use_date_range_moment: [],
        goods_ids: [],
        not_goods_ids: [],
        user_group: [],
        seller_group: [],
        status: 1,
        single_use: 1,
        auto_get: '',
        get_limit: '',
        goods_show: 2,
        goods_show_title: '',
        need_subscribe: 2
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      form: this.$form.createForm(this),
      mdl: {},
      userFormData: {
        user_list: undefined,
        count: 1
      },

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: ''
      },
      cateOptions: [],
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '标题',
          dataIndex: 'title',
          scopedSlots: { customRender: 'title1' }
        },
        {
          width: '200px',
          title: '使用时限',
          dataIndex: 'use_time_start',
          scopedSlots: { customRender: 'timeRange' }
        },
        {
          width: '100px',
          title: '领取限制',
          dataIndex: 'user_get_num_limit',
          scopedSlots: { customRender: 'userGetNumLimit' }
        },
        {
          title: '已使用/领取人/次',
          width: '150px',
          dataIndex: 'order_count',
          scopedSlots: { customRender: 'orderCount' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData',)
        console.log(this.queryParam)
        this.queryParam = Object.assign( this.queryParam,parameter)
        return getCouponList(this.queryParam).then(res => {
          console.log('res')
          return res.data
        })
      },

      selectedRowKeys: [],
      selectedRows: [],
      goodsOptions: [],

      //领取人员表头
      userColumns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '100px'
        },
        {
          title: '用户名',
          dataIndex: 'user_name',
          width: '150px',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'name'
          }
        },
        {
          title: '面额',
          width: '150px',
          dataIndex: 'price',
          customRender: text => {
            return (text / 100).toFixed(2)
          }
        },
        {
          title: '状态',
          width: '100px',
          dataIndex: 'user_status',
          scopedSlots: {
            customRender: 'status'
          },
          filters: [
            {
              text: '未使用',
              value: '1'
            },
            {
              text: '已使用',
              value: '2'
            },
            {
              text: '已失效',
              value: '3'
            }
          ],
          filterMultiple: false
        },
        {
          title: '领取时间',
          width: '150px',
          dataIndex: 'user_create_time',
          customRender: text => {
            return moment(text * 1000).format('YYYY-MM-DD HH:mm:ss')
          }
        },
        {
          title: '使用时间',
          width: '150px',
          dataIndex: 'use_time',
          customRender: text => {
            if (!text) {
              return '-'
            }
            return moment(text * 1000).format('YYYY-MM-DD HH:mm:ss')
          }
        }
      ],
      userPagination: {
        pageSize: 30,
        p: 1,
        showTotal: total => {
          return '总计' + total + '条'
        }
      },
      userQuery: {
        youhuiquan_id: 0,
        status: 0,
        p: 1,
        keywords: undefined
      },
      couponUserList: []
    }
  },
  computed: {},
  created() {},
  mounted() {
    let that = this
    that.getGoodsOptions()
  },
  methods: {
    moment,
    //    批量发送优惠券
    setSend(record) {
      let data={
        type: 1,
        youhuiquan_id:record.id,
        seller_group:'',
        user_ids: this.userFormData.user_list,
        count: 1
      }
      sendCoupon(data).then(res=>{
        console.log(res)
        this.$message.success(res.msg)
        this.userFormData.user_list=[]
      })
    },
    handleCancel() {
      this.visible = false
    },
    // 增
    handleAdd() {
      let that = this
      this.visible = true
      this.form.resetFields()
      this.formData = {
        id: 0,
        title: '',
        desc: '',
        count: '',
        price_type: 1,
        price_start: '',
        price_end: '',
        price_limit: '',
        user_get_num_limit: '',
        use_day_limit: '',
        get_date_range: [],
        get_date_range_moment: [],
        use_date_type: 1,
        use_date_range: [],
        use_date_range_moment: [],
        goods_ids: [],
        not_goods_ids: [],
        user_group: [],
        seller_group: [],
        status: 1,
        single_use: 1,
        auto_get: '',
        get_limit: '',
        goods_show: 2,
        goods_show_title: '',
        need_subscribe: 2
      }
      setTimeout(() => {
        that.form.setFieldsValue({ ...this.formData })
      })
    },
    // 改
    handleEdit(record) {
      let self = this
      getCouponDetail({ id: record.id }).then(res => {
        setTimeout(() => {
          self.form.setFieldsValue({ ...res.data })
        }, 1)
        //          self.formData = {...res.data};
        self.formData = Object.assign(self.formData, res.data) //尼玛 日期选择器有bug 必须这样赋值
        self.formData.id = res.data.id
        self.formData.get_date_range_moment = [
          moment(res.data.get_time_start * 1000),
          moment(res.data.get_time_end * 1000)
        ]
        
        if (self.formData.use_date_type == 1) {
          self.formData.use_date_range_moment = [
            moment(res.data.use_time_start * 1000),
            moment(res.data.use_time_end * 1000)
          ]
        } else {
          self.formData.use_date_range_moment = []
        }
        this.visible = true
      })
    },

    // 增改 处理
    handleOk(e) {
      let self = this
      e.preventDefault()
      if (self.formData.get_date_range_moment.length != 2) {
        self.$message.error('请选择领取时限')
        return
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.formData)
          self.saveLoading = true
          self.formData.use_date_range =
            self.formData.use_date_range_moment.length == 2
              ? [
                  self.formData.use_date_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
                  self.formData.use_date_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
                ]
              : []
          let formData = {
            id: self.formData.id,
            title: values.title,
            desc: values.desc,
            count: values.count,
            price_type: self.formData.price_type,
            price_start: self.formData.price_start,
            price_end: self.formData.price_end,
            price_limit: self.formData.price_limit,
            user_get_num_limit: values.user_get_num_limit,
            use_day_limit: values.use_day_limit,
            get_date_range: [
              self.formData.get_date_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
              self.formData.get_date_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
            ],
            use_date_type: self.formData.use_date_type,
            use_date_range: self.formData.use_date_range,
            goods_ids: self.formData.goods_ids,
            not_goods_ids: self.formData.not_goods_ids,
            user_group: [],
            seller_group: [],
            status: self.formData.status,
            single_use: self.formData.single_use,
            auto_get: self.formData.auto_get,
            get_limit: self.formData.get_limit,
            goods_show: self.formData.goods_show,
            goods_show_title: values.goods_show_title,
            need_subscribe: self.formData.need_subscribe
          }
          if (self.formData.id) {
            editCoupon(formData)
              .then(res => {
                self.$message.success('修改成功')
                self.$refs.table.refresh(true)
                self.visible = false
                self.saveLoading = false
              })
              .catch(err => {
                self.$message.error(err.data.msg)
                self.saveLoading = false
              })
          } else {
            addCoupon(formData)
              .then(res => {
                self.$message.success('新增成功')
                self.$refs.table.refresh(true)
                self.visible = false
                self.saveLoading = false
              })
              .catch(err => {
                self.$message.error(err.data.msg)
                self.saveLoading = false
              })
          }
        }
      })
    },
    // 查
    onSearch() {
      let self = this
      self.$refs.table.refresh(true)
    },
    setAllStatus(status) {
      let self = this
      setCouponAllStatus({
        ids: self.selectedRowKeys,
        status: status
      }).then(res => {
        self.$message.success('设置成功')
        self.$refs.table.refresh(true)
      })
    },
    // 删
    deleteHandle(record) {
      let self = this
      deleteCoupon({ id: record.id })
        .then(res => {
          self.$message.success('删除成功')
          self.$refs.table.refresh(true)
        })
        .catch(err => {
          self.$message.error(err.data.msg)
        })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    getGoodsOptions() {
      let self = this
      getGoodsOptions()
        .then(res => {
          self.goodsOptions = res.data
        })
        .catch(err => {
          self.$message.error(err.data.msg)
        })
    },

    handleUserManage(record) {
      let self = this
      self.userQuery.youhuiquan_id = record.id
      self.userQuery.keywords = undefined
      self.userQuery.status = undefined
      self.userPagination.p = 1
      self.fetchUserList()
      this.userVisible = true
    },

    fetchUserList() {
      let self = this
      getCouponUserList(Object.assign(self.userQuery, self.userPagination)).then(res => {
        self.couponUserList = res.data.list
        const pagination = { ...this.userPagination }
        pagination.total = res.data.total
        self.userPagination = pagination
      })
    },

    userSearch(selectedKeys, confirm) {
      let self = this
      confirm()
      self.fetchUserList()
    },
    userSearchReset(selectedKeys, confirm) {
      let self = this
      confirm()
      self.userQuery.keywords = undefined
      self.fetchUserList()
    },
    handleUserTableChange(pagination, filters, sorter) {
      console.log('filters', filters)
      let that = this
      if (filters.user_status) {
        that.userQuery.status = filters.user_status[0]
      } else {
        that.userQuery.status = 0
      }
      const pager = { ...this.pagination }
      pager.current = pagination.current
      that.pagination = pager
      that.userQuery.p = pagination.current

      pager.p = pagination.current
      that.userPagination = pager

      that.fetchUserList()

    },
    onShare(record) {
      let that = this
      that.shareVisible = true
      that.share.wxmini_pic_url = record.wxmini_pic_url
    },
     onH5Share(record) {
      console.log(record)
      let that = this
      that.share.site_url=record.h5_url
      that.h5ShareVisible = true
      that.share.wxmini_pic_url = record.h5_pic_url
    },
    onCopy(e){
      this.$message.success('复制成功')
      },
      onError(e){
        this.$message.error('复制失败')
      }
  },

  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  }
}
</script>


<style scoped>
.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
</style>